document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth"
    });
  });
});

jQuery(function($){
    //Append Variant Name to title
    var productTitle = $('.productid-8532488618146 .product__title h1');
    productTitle.append('<span></span>');

  //Check and change selected value on variant change
    $('.productid-8532488618146 input[name="Size"]').on('change', function(){
        var selecTed = $(this).val();
        productTitle.find('span').text(selecTed);
    });

    //Check and change selected value on page load
    var selectedVariant = $('.productid-8532488618146 input[name="Size"]:checked').val();
    productTitle.find('span').text(selectedVariant);

    if ($(window).width() < 767) {
      const starRating = $('.product__title + div[id^="shopify-block-okendo_star_rating"]');
      // Move it to be right after h1.rich-text__heading.h0
      $('h1.rich-text__heading.h0').after(starRating);
    }
  
  $('.ing-title a').on('click', function(e){
      var selectedtab = $(this).attr('data-tab');
      $('.active-title').removeClass('active-title');
      $('.ing-tab').removeClass('active');
      $(this).addClass('active-title');
      $('.'+selectedtab).addClass('active');
      $(this).parent().parent().removeClass();
      $(this).parent().parent().addClass('selected-'+selectedtab);

      e.preventDefault();
    });

  $('.how-title a').on('click', function(e){
      var selectedtab = $(this).attr('data-tab');
      $('.active-htitle').removeClass('active-htitle');
      $('.how-tab').removeClass('active-htab');
      $(this).addClass('active-htitle');
      $('.'+selectedtab).addClass('active-htab');
      $(this).parent().parent().removeClass();
      $(this).parent().parent().addClass('selected-'+selectedtab);

      e.preventDefault();
    });
});

